import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from "@angular/router";
import { Observable } from "rxjs";
import { V2AuthService } from "../services/v2auth.service";
import { UserState } from "../store/reducers/user.reducers";
import { Store } from "@ngrx/store";
import { selectCurrentUser, selectUserInfo } from "../store/selectors/user.selectors";
import { catchError, map, switchMap, take } from "rxjs/operators";
import { UserService } from "../services/user.service";
import { UserActions } from "../store/actions/user.actions";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  currentUser$: Observable<any>;
  toasterService: any;

  constructor(
    private router: Router,
    private auth: V2AuthService,
    private userService: UserService,
    private store: Store<{ user: UserState }>
  ) { }

  canActivate(): any {
    if (!this.auth.getToken()) {
      this.router.navigate(["/login"]);
      return false;
    }

    this.currentUser$ = this.store.select(selectCurrentUser);

    this.currentUser$.subscribe((user) => {
      if (!user) {
        this.userService.getCurrentUser().subscribe({
          next: (user) => {
            if (user?.userId) {
              this.currentUser$ = user;
              this.store.dispatch(UserActions.registerCurrentUser({ user }));
              this.userService.getUserById(Number(user.userId)).subscribe((res) => {
                this.store.dispatch(UserActions.registerUserInfo({ user: res }));
              });
            } else {
              this.handleError(null, "Invalid user data received.");
            }
          },
          error: (err) => this.handleError(err, "Error while fetching current user."),
        });
      }
    });

    return true;
  }

  private handleError(error: any, message: string): void {
    sessionStorage.clear();
    localStorage.clear();
    localStorage.setItem("error", message);
    localStorage.setItem("error--v", JSON.stringify(error));
    this.auth.logout();
  }
}